@import "../../global/temporary-mercury-overrides/_button.scss";

section {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr max-content;
}

.main {
  position: relative;
  display: contents;
}

.input-file {
  display: flex;
}

.field {
  width: 100%;
}

.dialog-header__operations,
.dialog-header__description {
  padding-block-start: 16px;
}

.header__field-group {
  grid-template:
    "import-file-label import-file-name buttons-container" max-content
    "module-folder-label module-folder module-folder" max-content
    / max-content 1fr max-content;
}
.module-folder-name {
  grid-area: module-folder;
}
.module-folder-label {
  grid-area: module-folder-label;
}
.import-file-label {
  grid-area: import-file-label;
}

.header__buttons-container {
  grid-area: buttons-container;
}

.section-grid {
  display: grid;
  grid-template:
    "top-content-operations top-content-description" max-content
    "operations-area operations-description" 1fr
    / 1fr 1fr;
  background-color: var(--items-container__bg-color);
  border-style: var(--items-container__border-style);
  border-width: var(--items-container__border-width);
  border-color: var(--items-container__border-color);
  border-block-start: 0;
  overflow-y: auto;
}

.list-wrapper {
  grid-area: operations-area;
  border-inline-end: var(--section-common-border);
}
.label {
  margin-block-start: 8px !important;
}

.tree-operations::part(item__header) {
  // WA Since this is a tree without parent node.
  // This componnent should ideally by an action-list,
  // but at the time of writting it doesn't support checkboxes.
  padding-inline-start: 0;
}

.procedure-description {
  grid-area: operations-description;
  overflow: auto;
  text-align: justify;
}

.dialog-header__operations {
  grid-area: top-content-operations;
  background-color: var(--items-container__bg-color);
}

.dialog-header__description {
  grid-area: top-content-description;
  background-color: var(--items-container__bg-color);
}
.text-align-center {
  text-align: center;
}
